import '@cloudscape-design/global-styles/index.css';
import '@aws-amplify/ui-react/styles.css';
import './app/styles/theme.css';

import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './app';

// Configure AWS Amplify with Cognito settings from environment variables
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        email: true,
        ...(cognitoDomain ? {
          oauth: {
            domain: cognitoDomain,
            scopes: ['email', 'openid'],
            redirectSignIn: [import.meta.env.VITE_REDIRECT_URL ?? 'http://localhost:5173/'],
            redirectSignOut: [import.meta.env.VITE_SIGNOUT_URL ?? 'http://localhost:5173/'],
            responseType: 'code',
          },
        } : {}),
      },
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 seconds
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
